/* ============================================================
   AQ — Les numéros portent leur format. 2026-10-25.

   Règle de Félix du 2026-10-25 : partout où un numéro est demandé
   dans les pipelines, le format est forcé dans le champ et un
   exemple sert de placeholder.

   Cette règle RENVERSE le lot 98, qui interdisait tout texte
   d'exemple dans un champ. L'arrachage du texte que Google Places
   dépose dans les champs d'adresse et de ville reste en place :
   « Indiquez un lieu » est une invite, pas un exemple de format.
   Ce fichier ne touche à aucun champ d'adresse ni de ville.

   POURQUOI UN FICHIER À PART plutôt qu'une correction dans chaque
   tunnel : les quatre tunnels ont chacun leur copie du masque de
   téléphone, et les champs de l'équipe, des représentants et des
   attributs de produit sont construits en JavaScript à l'exécution.
   Une table unique, appliquée à l'arrivée de chaque champ, évite
   de réécrire cinq fichiers et de créer une sixième copie.

   CE QU'IL FAIT, et rien d'autre :
   · pose un placeholder d'exemple ;
   · pose inputmode, maxlength et pattern quand ils manquent ;
   · ajoute un filtre de frappe SEULEMENT aux champs qui n'en ont
     aucun. Les masques existants du téléphone et de la licence RBQ
     ne sont jamais doublés ni remplacés.

   CE QU'IL NE FAIT PAS : il ne valide rien à l'envoi. Les tunnels
   ne sont pas des <form>, donc pattern n'y bloque rien ; il est
   posé pour le clavier mobile, les outils d'assistance et une
   éventuelle validation future. Les contrôles d'envoi restent où
   ils sont.

   LES EXEMPLES viennent des sources de vérité, jamais d'une forme
   inventée :
   · licence RBQ, trois blocs 4-4-2 séparés de tirets, « Licence
     RBQ : XXXX-XXXX-XX » (Régie du bâtiment du Québec) ;
   · code postal au format A1A 1A1 (Postes Canada) ;
   · téléphone dans la plage 555-01XX, réservée aux exemples, donc
     aucun vrai abonné n'est joint par erreur.
   Aucun exemple n'est posé sur un numéro dont le format n'est pas
   documenté publiquement : numéros de membre des ordres et des
   associations, numéro d'enregistrement d'une DEP. Un faux exemple
   y ferait plus de tort que pas d'exemple du tout.
   ============================================================ */
(function () {
  'use strict';

  /* ————— la table des numéros —————
     cle    : valeur de data-aqf, ou repère du champ construit en JS
     ex     : le placeholder
     im     : inputmode
     max    : maxlength
     pat    : pattern
     filtre : 'entier' | 'decimal' | 'cp' | null  (filtre de frappe
              posé SEULEMENT si le champ n'en a pas déjà un) */
  var TABLE = {
    /* ——— acteur ——— */
    founded_year:   { ex: '1998',          im: 'numeric', max: 4,  pat: '[0-9]{4}' },
    rbq_license:    { ex: '1234-5678-01',  im: 'numeric', max: 12, pat: '[0-9]{4}-[0-9]{4}-[0-9]{2}' },
    postal_code:    { ex: 'A1A 1A1',       im: 'text',    max: 7,  pat: '[A-Za-z][0-9][A-Za-z] ?[0-9][A-Za-z][0-9]', filtre: 'cp' },
    phone:          { ex: '514 555 0123',  im: 'tel',     max: 12 },
    contact_phone:  { ex: '514 555 0123',  im: 'tel',     max: 12 },

    /* ——— projet ——— */
    year:           { ex: '2024',          im: 'numeric', max: 4,  pat: '[0-9]{4}' },
    planned_year:   { ex: '2024',          im: 'numeric', max: 4,  pat: '[0-9]{4}' },   /* lot 7 : année prévue */
    floors:         { ex: '3',             im: 'numeric', max: 3,  pat: '[0-9]{1,3}',  filtre: 'entier' },
    units:          { ex: '24',            im: 'numeric', max: 5,  pat: '[0-9]{1,5}',  filtre: 'entier' },

    /* ——— emploi ——— */
    positions_count:{ ex: '1',             im: 'numeric', max: 2,  filtre: 'entier' },
    salary_min:     { ex: '65000',         im: 'numeric', max: 7,  filtre: 'entier' },
    salary_max:     { ex: '85000',         im: 'numeric', max: 7,  filtre: 'entier' }
  };

  /* La superficie du tunnel projet n'a pas de data-aqf sur le champ
     visible : elle sort dans un caché. L'exemple « 310 » est celui
     que le registre aq-champs-projet.json porte déjà sans jamais
     l'afficher. L'unité se choisit à côté, donc le champ ne prend
     que le nombre. */
  var PAR_SELECTEUR = [
    { sel: '[data-aqj-superficie-n]', ex: '310', im: 'decimal', max: 9 },

    /* Le téléphone d'un représentant est construit par
       assets/aq-representants.js, sans data-aqf et sans masque : il
       était le seul téléphone du thème où la frappe restait brute,
       avec un maxlength de 30 au lieu de 12. Il rejoint la forme des
       quatre autres. On le vise par son type, à l'intérieur du
       tunnel seulement, et on ne touche pas aux téléphones qui
       portent déjà un data-aqf, leurs masques existent. */
    { sel: '.aqp2 input[type="tel"]:not([data-aqf])', ex: '514 555 0123', im: 'tel', max: 12, filtre: 'tel' }
  ];

  function poser(el, r) {
    if (!el || el.getAttribute('data-aqnum') === 'fait') return;
    el.setAttribute('data-aqnum', 'fait');
    if (r.ex && !el.getAttribute('placeholder')) el.setAttribute('placeholder', r.ex);
    if (r.im && !el.getAttribute('inputmode')) el.setAttribute('inputmode', r.im);
    if (r.max && !el.getAttribute('maxlength')) el.setAttribute('maxlength', String(r.max));
    if (r.pat && !el.getAttribute('pattern')) el.setAttribute('pattern', r.pat);
    if (r.filtre) filtrer(el, r.filtre);
  }

  /* Un filtre n'est posé que si le champ n'en a aucun. On le repère
     au drapeau que les tunnels existants laissent, ou à la présence
     d'un masque déjà actif sur le champ. */
  function filtrer(el, genre) {
    if (el.getAttribute('data-aqnum-filtre') === 'fait') return;
    el.setAttribute('data-aqnum-filtre', 'fait');
    el.addEventListener('input', function () {
      var v = this.value, n = v;
      if (genre === 'entier') {
        n = v.replace(/\D/g, '');
      } else if (genre === 'decimal') {
        n = v.replace(/[^\d.,]/g, '');
      } else if (genre === 'tel') {
        /* Même forme que les quatre masques déjà en place dans les
           tunnels, 000 000-0000, pour que les cinq téléphones du
           site s'écrivent pareil. Au-delà de dix chiffres, on laisse
           passer : un numéro hors Amérique du Nord reste saisissable,
           la validation d'envoi s'en charge. */
        var d = v.replace(/\D/g, '').slice(0, 10);
        if (d.length > 6)      n = d.slice(0, 3) + ' ' + d.slice(3, 6) + '-' + d.slice(6);
        else if (d.length > 3) n = d.slice(0, 3) + ' ' + d.slice(3);
        else                   n = d;
      } else if (genre === 'cp') {
        /* Lettres et chiffres seulement, une espace posée après le
           troisième caractère. On met en forme, on ne refuse jamais :
           un code mal tapé reste corrigeable, il n'est pas effacé. */
        var b = v.replace(/[^A-Za-z0-9]/g, '').toUpperCase().slice(0, 6);
        n = b.length > 3 ? b.slice(0, 3) + ' ' + b.slice(3) : b;
      }
      if (n !== v) {
        var f = this.selectionStart === v.length;
        this.value = n;
        if (f) { try { this.setSelectionRange(n.length, n.length); } catch (e) {} }
      }
    });
  }

  function balayer(racine) {
    var r = racine || document;
    var cle, el, i, liste;
    for (cle in TABLE) {
      if (!TABLE.hasOwnProperty(cle)) continue;
      liste = r.querySelectorAll('[data-aqf="' + cle + '"]');
      for (i = 0; i < liste.length; i++) {
        el = liste[i];
        if (el.tagName === 'INPUT' && el.type !== 'hidden') poser(el, TABLE[cle]);
      }
    }
    for (i = 0; i < PAR_SELECTEUR.length; i++) {
      liste = r.querySelectorAll(PAR_SELECTEUR[i].sel);
      for (var j = 0; j < liste.length; j++) poser(liste[j], PAR_SELECTEUR[i]);
    }
  }

  /* Les champs de l'équipe, des représentants et des attributs de
     produit naissent après le premier rendu, et renaissent à chaque
     ajout d'une ligne. On rebalaye à chaque arrivée de nœud. */
  function surveiller() {
    var hote = document.querySelector('.aqp2') || document.body;
    if (!hote || !window.MutationObserver) return;
    var attente = null;
    new MutationObserver(function () {
      if (attente) return;
      attente = setTimeout(function () { attente = null; balayer(); }, 60);
    }).observe(hote, { childList: true, subtree: true });
  }

  function demarrer() { balayer(); surveiller(); }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', demarrer);
  } else {
    demarrer();
  }
})();
